import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "form-wrapper slide-up"
}
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = { class: "form-close" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = ["onUpdate:modelValue"]
const _hoisted_9 = {
  key: 2,
  class: "edit-form-field"
}
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = { class: "form-close" }
const _hoisted_12 = ["onSubmit"]
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = { key: 3 }
const _hoisted_15 = { key: 4 }
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 5,
  class: "checkbox-input",
  style: {"margin-top":"10px"}
}
const _hoisted_18 = ["onUpdate:modelValue"]
const _hoisted_19 = {
  key: 6,
  class: "checkbox-input",
  style: {"margin-top":"10px"}
}
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = {
  class: "checkbox-input",
  style: {"margin-top":"10px"}
}
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = { key: 7 }
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = { class: "edit-form-field" }
const _hoisted_26 = ["onUpdate:modelValue"]
const _hoisted_27 = { class: "form-close" }
const _hoisted_28 = ["onSubmit"]
const _hoisted_29 = ["onUpdate:modelValue"]
const _hoisted_30 = { style: {"display":"flex"} }
const _hoisted_31 = { style: {"margin-top":"25px"} }
const _hoisted_32 = { style: {"margin-top":"20px"} }
const _hoisted_33 = { class: "form-close" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_tip_tap = _resolveComponent("tip-tap")!
  const _component_drop_file = _resolveComponent("drop-file")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              type: "button",
              class: "form-close-x",
              title: "Close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            }, "×")
          ]),
          _cache[15] || (_cache[15] = _createElementVNode("h3", null, "Name", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.Name) = $event))
          }, null, 512), [
            [_vModelText, _ctx.formData.Name]
          ]),
          _createVNode(_component_draggable, {
            list: _ctx.formData.FieldsJSON
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.FieldsJSON, (field, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "edit-form-field"
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    (_openBlock(), _createElementBlock("svg", {
                      onClick: ($event: any) => (_ctx.removeField(i)),
                      fill: "red",
                      style: {"width":"18px","height":"18px"},
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "18",
                      height: "18",
                      viewBox: "0 0 24 24"
                    }, [...(_cache[6] || (_cache[6] = [
                      _createElementVNode("path", { d: "M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 16.538l-4.592-4.548 4.546-4.587-1.416-1.403-4.545 4.589-4.588-4.543-1.405 1.405 4.593 4.552-4.547 4.592 1.405 1.405 4.555-4.596 4.591 4.55 1.403-1.416z" }, null, -1)
                    ]))], 8, _hoisted_5))
                  ]),
                  (field.type != 'textblock' && field.type != 'image')
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        type: "text",
                        placeholder: "Question",
                        "onUpdate:modelValue": ($event: any) => ((field.label) = $event)
                      }, null, 8, _hoisted_6)), [
                        [_vModelText, field.label]
                      ])
                    : _createCommentVNode("", true),
                  (field.type != 'textblock' && field.type != 'image')
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 1,
                        type: "text",
                        placeholder: "Optional Description",
                        "onUpdate:modelValue": ($event: any) => ((field.description) = $event)
                      }, null, 8, _hoisted_7)), [
                        [_vModelText, field.description]
                      ])
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": ($event: any) => ((field.type) = $event)
                  }, [...(_cache[7] || (_cache[7] = [
                    _createElementVNode("option", { value: "text" }, "Text", -1),
                    _createElementVNode("option", { value: "textarea" }, "Multi-line Text", -1),
                    _createElementVNode("option", { value: "date" }, "Date", -1),
                    _createElementVNode("option", { value: "time" }, "Time", -1),
                    _createElementVNode("option", { value: "select" }, "Select", -1),
                    _createElementVNode("option", { value: "location" }, "Location", -1),
                    _createElementVNode("option", { value: "file" }, "File", -1),
                    _createElementVNode("option", { value: "multiplefiles" }, "Multiple Files", -1),
                    _createElementVNode("option", { value: "signature" }, "Signature (Drawing)", -1),
                    _createElementVNode("option", { value: "textblock" }, "Text Block (Display)", -1),
                    _createElementVNode("option", { value: "image" }, "Image (Display)", -1)
                  ]))], 8, _hoisted_8), [
                    [_vModelSelect, field.type]
                  ]),
                  (field.type == 'select')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_component_draggable, {
                          list: field.options
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, (option, j) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: 'o'+j,
                                style: {"position":"relative"}
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  style: {"padding":"5px 0","border":"0","margin":"0"},
                                  type: "text",
                                  "onUpdate:modelValue": ($event: any) => ((field.options[j]) = $event)
                                }, null, 8, _hoisted_10), [
                                  [_vModelText, field.options[j]]
                                ]),
                                _createElementVNode("div", _hoisted_11, [
                                  _createVNode(_component_svg_icon, {
                                    onClick: ($event: any) => (_ctx.removeOption(field.options, j)),
                                    style: {"color":"red","width":"12px","height":"12px"},
                                    icon: "x"
                                  }, null, 8, ["onClick"])
                                ])
                              ]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["list"]),
                        _createElementVNode("form", {
                          onSubmit: _withModifiers(($event: any) => (_ctx.addOption(field)), ["prevent"]),
                          style: {"display":"flex","margin":"5px 0"}
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            style: {"flex":"1","margin-bottom":"0"},
                            type: "text",
                            "onUpdate:modelValue": ($event: any) => ((field.optionInput) = $event),
                            placeholder: "Add Option"
                          }, null, 8, _hoisted_13), [
                            [_vModelText, field.optionInput]
                          ]),
                          _cache[8] || (_cache[8] = _createElementVNode("button", { class: "add-btn" }, "Add", -1))
                        ], 40, _hoisted_12)
                      ]))
                    : (field.type == 'textblock')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createVNode(_component_tip_tap, {
                            modelValue: field.textBlock,
                            "onUpdate:modelValue": ($event: any) => ((field.textBlock) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]))
                      : (field.type == 'image')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createVNode(_component_drop_file, {
                              onFileChange: ($event: any) => (_ctx.onImageChange($event, field)),
                              imageOnly: true
                            }, null, 8, ["onFileChange"]),
                            (field.imageURL)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  style: {"margin-top":"10px"},
                                  src: field.imageURL
                                }, null, 8, _hoisted_16))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                  (field.type != 'textblock' && field.type != 'image')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": ($event: any) => ((field.required) = $event)
                        }, null, 8, _hoisted_18), [
                          [_vModelCheckbox, field.required]
                        ]),
                        _cache[9] || (_cache[9] = _createElementVNode("div", null, "Required", -1))
                      ]))
                    : _createCommentVNode("", true),
                  (field.type != 'textblock' && field.type != 'image')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": ($event: any) => ((field.sensitive) = $event)
                        }, null, 8, _hoisted_20), [
                          [_vModelCheckbox, field.sensitive]
                        ]),
                        _cache[10] || (_cache[10] = _createElementVNode("div", null, "Sensitive Information", -1))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_21, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": ($event: any) => ((field.conditional) = $event)
                    }, null, 8, _hoisted_22), [
                      [_vModelCheckbox, field.conditional]
                    ]),
                    _cache[11] || (_cache[11] = _createElementVNode("div", null, "Show Conditionally", -1))
                  ]),
                  (field.conditional)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          placeholder: "Field Label",
                          "onUpdate:modelValue": ($event: any) => ((field.conditionalField) = $event)
                        }, null, 8, _hoisted_24), [
                          [_vModelText, field.conditionalField]
                        ]),
                        _cache[13] || (_cache[13] = _createElementVNode("div", { style: {"margin":"10px"} }, "Is Equal To", -1)),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.conditionalValuesArray, (option, j) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: 'o'+j,
                                style: {"position":"relative"}
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  style: {"padding":"5px 0","border":"0","margin":"0"},
                                  type: "text",
                                  "onUpdate:modelValue": ($event: any) => ((field.conditionalValuesArray[j]) = $event)
                                }, null, 8, _hoisted_26), [
                                  [_vModelText, field.conditionalValuesArray[j]]
                                ]),
                                _createElementVNode("div", _hoisted_27, [
                                  _createVNode(_component_svg_icon, {
                                    onClick: ($event: any) => (_ctx.removeOption(field.conditionalValuesArray, j)),
                                    style: {"color":"red","width":"12px","height":"12px"},
                                    icon: "x"
                                  }, null, 8, ["onClick"])
                                ])
                              ]))
                            }), 128))
                          ]),
                          _createElementVNode("form", {
                            onSubmit: _withModifiers(($event: any) => (_ctx.addConditionalValue(field)), ["prevent"]),
                            style: {"display":"flex","margin":"5px 0"}
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              style: {"flex":"1","margin-bottom":"0"},
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((field.conditionalValueInput) = $event),
                              placeholder: "Add Value"
                            }, null, 8, _hoisted_29), [
                              [_vModelText, field.conditionalValueInput]
                            ]),
                            _cache[12] || (_cache[12] = _createElementVNode("button", { class: "add-btn" }, "Add", -1))
                          ], 40, _hoisted_28)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["list"]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addItem())),
              class: "add-btn"
            }, "Add Item")
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("form", {
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.addRecipient()), ["prevent"])),
              style: {"display":"flex","margin-bottom":"5px"}
            }, [
              _withDirectives(_createElementVNode("input", {
                style: {"flex":"1","margin-bottom":"0"},
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.recipientInput) = $event)),
                placeholder: "Add Email Recipient"
              }, null, 512), [
                [_vModelText, _ctx.recipientInput]
              ]),
              _cache[14] || (_cache[14] = _createElementVNode("button", { class: "add-btn" }, "Add", -1))
            ], 32),
            _createElementVNode("div", _hoisted_32, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.RecipientsJSON, (recipient, j) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'r'+j,
                  style: {"position":"relative","margin-bottom":"5px"}
                }, [
                  _createElementVNode("div", null, _toDisplayString(recipient), 1),
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(_component_svg_icon, {
                      onClick: ($event: any) => (_ctx.removeRecipient(j)),
                      style: {"color":"red","width":"12px","height":"12px"},
                      icon: "x"
                    }, null, 8, ["onClick"])
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("input", {
            style: {"margin-top":"25px"},
            class: _normalizeClass(_ctx.disableButton ? 'disable-button' : ''),
            type: "submit",
            value: "Submit",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submit()))
          }, null, 2)
        ]))
      : _createCommentVNode("", true)
  ]))
}